export enum LODOptions {
    christmas = 'christmas',
    valentines = 'valentines',
    mothersday = 'mothersday',
    fathersday = 'fathersday',
    reyes = 'reyes',
}
